// tslint:disable-next-line: max-line-length
import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, ViewChild, AfterViewInit, ElementRef, Renderer2, OnDestroy, Input } from '@angular/core';
import { fromEvent, Subject } from 'rxjs';
import { ViewService } from '../../view.service';
import { Actions, ofActionCompleted, ofActionDispatched } from '@ngxs/store';
import { ViewActions } from '../../state/view.actions';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-view-loader',
  templateUrl: './view-loader.component.html',
  styleUrls: ['./view-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewLoaderComponent implements OnDestroy {


  constructor(
    private renderer: Renderer2,
    private viewService: ViewService,
    private actions: Actions
  ) { }
  // ---------- Child Elements ----------
  @ViewChild('viewLoader', { static: true })
  viewLoaderRef: ElementRef<HTMLElement>;


  // ---------- Class Variables ----------
  ngUnsubscribe = new Subject();


  // ---------- Class Methods ----------
  handleClick() {
    this.renderer.addClass(this.viewLoaderRef.nativeElement, 'view-loader--disappear');
    setTimeout(() => {
      this.viewService.toggleInteract(false);
    }, 250);
  }


  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
